import { createSlice } from "@reduxjs/toolkit";

const MAX_LIVE_ITEMS = 50;

const initialState = {
  liveItems: [],
  unreadCount: 0,
};

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    addLiveActivity(state, action) {
      state.liveItems = [action.payload, ...state.liveItems].slice(
        0,
        MAX_LIVE_ITEMS
      );
      state.unreadCount += 1;

      return state;
    },
    clearUnread(state) {
      state.unreadCount = 0;

      return state;
    },
    resetActivity() {
      return initialState;
    },
  },
});

export const activityActions = activitySlice.actions;

export default activitySlice.reducer;
